<p *ngIf="!error">
  Logging you in...
</p>
<p>
  {{ error }}
</p>
